import { render, staticRenderFns } from "./CommissionListXmlForm.vue?vue&type=template&id=08f263b1"
import script from "./CommissionListXmlForm.vue?vue&type=script&lang=js"
export * from "./CommissionListXmlForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports